<template slot="header">

  <div class="ti-table ti_border bc-gray"
       v-bind:class="{ ti_dashedborder: hasDashBorder, ti_space: !isHeader }"
       v-b-tooltip.hover
       v-b-tooltip.nofade="getTooltipText"
       v-if="getIsAvailable">

    <div class="ti-headerrow ti-cell"
         v-bind:class="{ ti_bg: isHeader, ti_bg_lite: !isHeader }">
      <div style="display: inline-flex; float:left;">
        <p v-bind:class="{ narrow_05: isNarrow, narrow_10: isVeryNarrow, localheading: isHeader }">
          <font-awesome-icon name="fa-thumbs-up" icon="star" v-if="hasStar"></font-awesome-icon>
          {{ getKpiName }}
        </p>
      </div>
      <div v-show="isHeader && hasNsc && !hideNSC" style="float: right; display: inline-flex">
        <NarrowNscItem v-if="kpi && overallByWave" :overallByWave="overallByWave" :kpi="kpi"  />
      </div>
    </div>

    <div class="ti-row">
      <div class="ti-cell">
        <performanceitem :invertArrow="invertArrow"
                         :overallByWave="overallByWave"
                         :kpi="getEffectiveKpi"
                         :showPrewaves="showPrewaves"
                         :monochrome="monochrome"
                         :isBMWMoto="isBMWMoto" />
      </div>
    </div>

    <div v-if="showNpsBar">
      <npsbar :kpi="kpi" />
    </div>
  </div>

</template>


<script>

  import npsbar from './NpsBar'
  import performanceitem from './PerformanceItem'
  import NarrowNscItem from './NarrowNscItem'

  export default {
    name: 'TableItem',
    components: {
      npsbar,
      performanceitem,
      NarrowNscItem
    },

    data() {
      return {
        lockedText: undefined
      }
    },
    props:{
      overallByWave: { type: Object, default: undefined },
      kpi: { type: Object, default: undefined },
      kpiPrewave: { type: Object, default: undefined },
      showPrewaves: { type: Boolean, default: true },
      hideNSC: { type: Boolean, default: false },
      nsckpi:  { type: Object, default: undefined },
      hasStar: { type: Boolean, default: false },
      hasOrangeBlock: { type: Boolean, default: false },
      isHeader: { type: Boolean, default: false },
      hasDashBorder: { type: Boolean, default: false },
      monochrome: { type: Boolean, default: false },
      isSmaller: { type: Boolean, default: false },
      invertArrow: { type: Boolean, default: false },
      isBMWMoto: { type: Boolean, default: false },
      showNpsBar: { type: Boolean, default: false },
      useTitleOverKpiName: { type: Boolean, default: false },
      titleText: { type: String, default: '' },
    },
    methods:{
      isLongText: function (text) {
        if (text === null) {
          return false;
        }
        return text.length > 24
      }
    },
    computed: {
      // creates a unified Kpi from "kpi" and "kpiPrewave". "kpi" is always needed.
      // If "kpiPrewave" is not set, "kpi" is returned as it was by default.
      // Else survey waves of "kpiPrewave" will be mapped to "kpi"
      getEffectiveKpi: function() {
        // no kpi, return 'undefined' kpi, if kpi and no prewave, just return kpi
        if (!this.kpi || (this.kpi && !this.kpiPrewave)) {
          return this.kpi;
        }

        // create a clone of kpi
        var clone = JSON.parse(JSON.stringify(this.kpi));
        // set sort order of waves to unsorted (untagged)
        clone.tagged = false;

        // keep actual waves
        var waves = clone.SurveyWave;

        // get all prewaves
        clone.SurveyWave = !this.kpiPrewave.SurveyWave ? [] : JSON.parse(JSON.stringify(this.kpiPrewave.SurveyWave));

        // remove all prewaves that are also included in actual waves
        clone.SurveyWave = _.remove(clone.SurveyWave, function(n) {
          return _.find(waves, ['Name', n.Name]) == undefined;
        });

        // add waves from actual wave
        _.forEach(waves, function(wave) {
          clone.SurveyWave.push(wave);
        });

        return clone;
      },
      getTooltipText: function() {
        if (!this.kpi || !this.kpi.QuestionText)
          return ''
        return this.kpi.QuestionText
      },
      isNarrow: function () {
        if (!this.kpi || !this.kpi.KpiName) { return false }
        return this.kpi.KpiName.length > 22 && this.kpi.KpiName.length <= 30
      },
      isVeryNarrow: function () {
        if (!this.kpi || !this.kpi.KpiName) { return false }
        return this.kpi.KpiName.length > 30
      },
      getKpiName: function() {
        if (!this.kpi || (!this.kpi.KpiName && !this.useTitleOverKpiName)) {
           return this.$t('Webportal.Dashboard.NotAvailable');
        }

        // locking is needed to prevent text from adhoc changing and flickering when user changes brands selection
        if (this.useTitleOverKpiName === true) {
          if (this.lockedText === undefined) {
            this.lockedText = this.titleText;
          }
          return this.lockedText;
        }

        return this.showNpsBar ? this.kpi.KpiName + '*' : this.kpi.KpiName;
      },
      getIsAvailable: function() {
        if (!this.kpi) {
          return false
        }
        if (!this.kpi.KpiName && !this.showNpsBar) {
          return false;
        }
        return true
      },
      hasNsc: function() {
        if (!this.kpi || !this.kpi.SurveyWave || _.size(this.kpi.SurveyWave) === 0) {
          return false
        }
        var result =  this.kpi.SurveyWave[0].ResultNSC
        return result  != undefined
      }
    }
  }

</script>


<style scoped>

  .localheading {
     font-size: 12pt;
  }

  .narrow {
    letter-spacing: -0.05em;
    width: 160px;
    text-overflow: ellipsis;
  }

  dic.ti-cell{
    align-content: center;
    align-content: space-around;
  }

  p{
    font-size: 8pt;
    font-weight: bold;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    margin-left: 3px;
  }

</style>
